if (!customElements.get("collection-accordion")) {
  class CollectionAccordion extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        collapsibleTabs: ["collapsible-tab"],
      };
    }

    init() {
      this.domNodes = queryDomNodes(this.selectors, this);
      this.hoverToOpen =
        this.dataset.triggerBehavior &&
        this.dataset.triggerBehavior === "hover" &&
        window.matchMedia("(hover: hover)").matches
          ? true
          : false;
    }

    connectedCallback() {
      this.init();
      this.onDesktopButtonWrapClickBound = this.onDesktopButtonWrapClick.bind(this);
      this.onCollapsibleTabSelectedBound = this.onCollapsibleTabSelected.bind(this);
      this.onCollapsibleTabUnselectedBound = this.onCollapsibleTabUnselected.bind(this);

      window.MinimogEvents.subscribe("ON_COLLAPSIBLE_TAB_SELECTED", this.onCollapsibleTabSelectedBound);
      window.MinimogEvents.subscribe("ON_COLLAPSIBLE_TAB_UNSELECTED", this.onCollapsibleTabUnselectedBound);

      this.domNodes.collapsibleTabs.forEach((collapsibleTab) => {
        const buttonWrap = collapsibleTab.querySelector(".collapsible__button-wrap");
        buttonWrap &&
          buttonWrap.addEventListener("click", this.onDesktopButtonWrapClickBound, {
            capture: true,
          });
      });

      if (this.hoverToOpen) {
        this.domNodes.collapsibleTabs.forEach((collapsibleTab) => {
          collapsibleTab.addEventListener("mouseenter", this.onMouseEnterCollapsibleTabs.bind(this));
        });
      }

      this.syncDesktopTabAria();
    }

    onCollapsibleTabSelected(collapsibleTab) {
      if (!collapsibleTab.classList.contains("collection-accordion")) return;
      const collectionAccordion = collapsibleTab.closest("collection-accordion");
      if (!collectionAccordion || collectionAccordion !== this) return;
      this.onElementSelected(collapsibleTab);
      this.syncDesktopTabAria();
    }

    onCollapsibleTabUnselected(collapsibleTab) {
      if (!collapsibleTab.classList.contains("collection-accordion")) return;
      const collectionAccordion = collapsibleTab.closest("collection-accordion");
      if (!collectionAccordion || collectionAccordion !== this) return;

      if (this.isDesktop()) {
        const hasSelectedTab = Array.from(this.domNodes.collapsibleTabs).some((tab) => this.isTabSelected(tab));
        if (!hasSelectedTab) {
          collapsibleTab.open();
          return;
        }
      }

      this.syncDesktopTabAria();
    }

    onElementSelected(collapsibleTab) {
      // No images to handle
    }

    onDesktopButtonWrapClick(event) {
      if (!this.isDesktop()) return;
      const collapsibleTab = event.currentTarget.closest("collapsible-tab");
      if (collapsibleTab && collapsibleTab.classList.contains("is-expanded")) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    }

    syncDesktopTabAria() {
      this.domNodes.collapsibleTabs.forEach((collapsibleTab) => {
        const trigger = collapsibleTab.querySelector("[data-trigger]");
        if (!trigger) return;
        trigger.setAttribute("aria-selected", this.isTabSelected(collapsibleTab) ? "true" : "false");
      });
    }

    isDesktop() {
      return window.matchMedia("(min-width: 1024px)").matches;
    }

    isTabSelected(collapsibleTab) {
      return (
        collapsibleTab.selected ||
        collapsibleTab.classList.contains("is-expanded") ||
        collapsibleTab.getAttribute("open") === "true"
      );
    }

    onMouseEnterCollapsibleTabs(event) {
      event.target.toggle(event);
    }

    disconnectedCallback() {
      this.domNodes.collapsibleTabs.forEach((collapsibleTab) => {
        const buttonWrap = collapsibleTab.querySelector(".collapsible__button-wrap");
        buttonWrap &&
          buttonWrap.removeEventListener("click", this.onDesktopButtonWrapClickBound, {
            capture: true,
          });
      });

      if (this.hoverToOpen) {
        this.domNodes.collapsibleTabs.forEach((collapsibleTab) => {
          collapsibleTab.removeEventListener("mouseenter", this.onMouseEnterCollapsibleTabs.bind(this));
        });
      }
    }
  }
  customElements.define("collection-accordion", CollectionAccordion);
}